import type { ReactNode } from "react";

import type { ProgramTemplate } from "../lib/api";

const WHERE: Record<ProgramTemplate["where"], string> = { gym: "зал", home: "дом" };

/**
 * Карточка готовой программы (21-retention-plan.md §4).
 *
 * Отвечает на три вопроса до тапа: для кого (уровень, где), сколько времени
 * (раз в неделю, недель) и что внутри (названия тренировок). Кнопки — снаружи:
 * в галерее, знакомстве и на главной действие разное.
 */
export default function TemplateCard({
  template,
  children,
}: {
  template: ProgramTemplate;
  children?: ReactNode;
}) {
  return (
    <div className="card tpl">
      <span className="tpl__chips">
        <span className="tpl__chip">{template.level}</span>
        <span className="tpl__chip">{WHERE[template.where]}</span>
        <span className="tpl__chip">{template.days_per_week}× в неделю</span>
        <span className="tpl__chip">{template.weeks} недель</span>
      </span>
      <span className="tpl__name">{template.name}</span>
      <span className="lead tpl__about">{template.description}</span>
      <span className="tpl__days">{template.day_names.join(" · ")}</span>
      {children && <span className="tpl__actions">{children}</span>}
    </div>
  );
}
